import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, FormGroup, Label, Input, Alert, Modal,
    ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../estilos.css';
import {
    listRecibaSerialess, listAutorizacioness, listUsuarioss
} from '../../graphql/queries';
import {
    updateAutorizaciones, updateRecibaSeriales,
    updateRecibaSerialesMP
} from '../../graphql/mutations';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment, { updateLocale } from 'moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink, CSVDownload } from "react-csv";
import { GetAutorizaciones, GetRecibaSeriales, GetRecibaSerialesID, GetUsuarios } from '../queries/Queries';
import { generateClient } from "aws-amplify/api";

const API = generateClient();



function Autorizaciones() {
    //Declaración de variables                    
    const [autorizaciones, setAutorizaciones] = useState([]);
    const [autorizacionesSinFIltro, setAutorizacionesSinFIltro] = useState([]);
    const [autorizacionModificar, setAutorizacionModificar] = useState([]);
    const [resolucion, setResolucion] = useState("");
    const [motivosR, setMotivosR] = useState("");
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pAutorizaciones = window.$Autorizaciones;
    const [cargando, setCargando] = useState(false);
    const [aVisible, setAVisible] = useState(false);
    const [nombreCompletoUsuario, setnombreCompletoUsuario] = useState("");
    const onDismiss = () => setAVisible(false);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [searchBy, setSearchBy] = useState("cliente");
    const [search, setSearch] = useState("");
    const [resolucionAutorizacion, setResolucionAutorizacion] = useState("todos");
    const [totalRecords, setTotalRecords] = useState(0);
    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();

    const dia = new Date().getDay();
    now2.setDate(now2.getDate() - dia);
    now.setDate(now.getDate() + (6 - dia));

    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));

    // current page
    const [currentPage, setCurrentPage] = useState(1);

    // total records per page to display
    const recordPerPage = 20;

    // total number of the records
    //const totalRecords = 40;

    // range of pages in paginator
    const pageRange = 5;

    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCargando(false);
        setCurrentPage(pageNumber);
        busqueda(autorizacionesSinFIltro, searchBy, search, resolucionAutorizacion, pageNumber);
    }

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const toggle = () => setModal(!modal);
    const toggle2 = () => setModal2(!modal2);

    //función para la búsqueda
    async function busqueda(autorizacionessinf, searchb, search, resolucionautorizacion, currentPage) {
        var pag = 1;
        var bandera = 1;
        //Filtrado de datos por la búsqueda y la resolución de la autorización
        const autorizacionesFromAPI = autorizacionessinf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(bautorizacion =>
                resolucionautorizacion === "todos" ? bautorizacion.resolucion === bautorizacion.resolucion :
                    resolucionautorizacion === "" ? !bautorizacion.resolucion :
                        resolucionautorizacion === bautorizacion.resolucion).filter(bautorizacion =>
                            searchb === "número de parte" ? bautorizacion.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                                searchb === "cliente" ? bautorizacion.cliente.toLowerCase().includes(search.toLowerCase()) :
                                    searchb === "serial" ? bautorizacion.serial.toLowerCase().includes(search.toLowerCase()) :
                                        searchb === "serialBTI" ? bautorizacion.serialRecibaBTI ? bautorizacion.serialRecibaBTI.toLowerCase().includes(
                                            search.toLowerCase()) : "".includes(search.toLowerCase()) :
                                            searchb === "tipo de petición" ? bautorizacion.peticionTipo.toLowerCase().includes(search.toLowerCase()) :
                                                searchb === 'módulo' ? bautorizacion.peticionModulo.toLowerCase().includes(search.toLowerCase()) :
                                                    searchb === 'motivos' ? bautorizacion.peticionMotivos.toLowerCase().includes(search.toLowerCase()) :
                                                        search === "" ? bautorizacion.peticionFecha === bautorizacion.peticionFecha :
                                                            Moment(bautorizacion.peticionFecha).format("DD/MM/YYYY") === Moment(search).format("DD/MM/YYYY"));

        await Promise.all(autorizacionesFromAPI.map(async bautorizacion => {
            bautorizacion.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return bautorizacion;
        }))

        const lengthproductos = autorizacionesFromAPI.length;
        if (lengthproductos <= 0)
            setCurrentPage(1);

        setAutorizaciones(autorizacionesFromAPI.filter(bautorizacion => bautorizacion.indexpag === currentPage).sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
        setTotalRecords(lengthproductos);

        if (currentPage > 1 && lengthproductos > 0) {
            const prepaginas = parseInt(lengthproductos / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthproductos ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const productosFromAPIp = autorizacionesFromAPI.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(bautorizacion =>
                        bautorizacion.indexpag === paginas);
                setAutorizaciones(productosFromAPIp.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
            }
        }
    }

    //Método useEffect
    useEffect(() => {
        fetchAutorizaciones();
    }, []);

    //Obtiene los datos guardados de las autorizaciones
    async function fetchAutorizaciones() {
        //Se obtienen los usuarios
        //Filtro por nombre de usario   
        setCargando(true);
        var nombreCompleto = "";
        var AutorizarTodo = false;
        //Se obtienen los datos del usuario.
        const apiDataU = await GetUsuarios({ usuario: { eq: userName } });
        nombreCompleto = await apiDataU[0].nombreCompleto;
        AutorizarTodo = !apiDataU[0].AutorizarTodo ? false : apiDataU[0].AutorizarTodo;
        setnombreCompletoUsuario(nombreCompleto);

        //Filtro por autorización activa y no cancelada
        var filter = {}
        if (AutorizarTodo === false) {
            filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    peticionUAutorizar: {
                        contains: nombreCompletoUsuario === "" ? nombreCompleto : nombreCompletoUsuario
                    }
                },
                {
                    cancelado: {
                        eq: false
                    }
                }]
            }
        } else {
            filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    cancelado: {
                        eq: false
                    }
                }]
            }
        }
        //Se obtienen los datos de las autorizaciones
        const apiData = await GetAutorizaciones(filter);
        const autorizacionesFromAPI = apiData.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);

        setAutorizacionesSinFIltro(autorizacionesFromAPI);
        busqueda(autorizacionesFromAPI, searchBy, search, resolucionAutorizacion, currentPage);

        setCargando(false);

    }

    //Revisa cambios en la fecha de búsqueda
    function onChangesRFecha(e) {
        e.persist()
        var fechafin = rfechafin;
        var fechaini = rfechaini;
        if (e.target.name === "fechaIni") {
            setRfechaini(e.target.value);
            fechaini = e.target.value;
        }
        else {
            setRfechafin(e.target.value);
            fechafin = e.target.value;
        }
        fetchAutorizaciones();

    }
    function clicAutorizar(autorizacion) {
        setAutorizacionModificar(autorizacion);
        setMotivosR(autorizacion.resolucionComentarios ? autorizacion.resolucionComentarios : "");
        setResolucion(autorizacion.resolucion ? autorizacion.resolucion : "");
        setModal(!modal)
    };
    async function resolucionSolicitud() {
        setModal(!modal)
        setAVisible(false);
        setCargando(true);
        try {
            //Se revisa que estén todos los datos
            if (!motivosR || !resolucion) {
                window.scrollTo(0, 0);
                setMensajeAlert("Faltan datos, por favor elige una resolución: " + resolucion + " y los motivos: " + motivosR);
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si el usuario ingreso los datos requeridos, se procede con las demás validaciones
            var pConcurrencia = false;
            var solicitado = false;
            //Se obtienen los datos de la solicitud por id para revisar la concurrencia            
            const solicitudFromAPI = await GetAutorizaciones({ id: { eq: autorizacionModificar.id } });
            setMensajeAlert("Revisando datos1");
            //Se revisa si existe concurrencia
            if (solicitudFromAPI.length !== 1) {
                pConcurrencia = true;
            } else {
                if (autorizacionModificar.updatedAt !== solicitudFromAPI[0].updatedAt)
                    pConcurrencia = true;
            }
            setMensajeAlert("Revisando datos2: " + autorizacionModificar.recibaSerialID);
            //Se obtienen los datos de la reciba por id para revisar si no se ha cancelado la solicitud           
            const recibaSFromAPI = await GetRecibaSerialesID(autorizacionModificar.recibaSerialID);
            //Se revisa si ya se canceló la solicitud       
            //solicitado = recibaSFromAPI.solNoFIFO ? recibaSFromAPI.solNoFIFO : false;
            /*if (solicitado === false) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: Ya se encuentra cancelada la solicitud para no usar el FIFO para el material en cuestión.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }*/
            setMensajeAlert("Revisando datos3");
            /* const planificado = recibaSFromAPI.cantidadPlaneada ? recibaSFromAPI.cantidadPlaneada > 0 ? true : false : false;
             if (planificado === true) {
                 window.scrollTo(0, 0);
                 setMensajeAlert("No fue posible realizar la operación: El material en cuestión ya se encuentra planificado.");
                 setColor("warning");
                 setCargando(false);
                 setAVisible(true);
                 return;
             }*/
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca que y se registra la resolución y motivos de la autorización
            if (pConcurrencia === false) {
                //Se marca en Reciba seriales como cancelada la solicitud poniendo solNoFIFO = false
                const datosReciba = recibaSFromAPI;
                delete datosReciba.createdAt;
                delete datosReciba.updatedAt;
                delete datosReciba.__typename;
                setMensajeAlert("Revisando datos4");
                //Si se trata de Petición 1. Autorizar no aplicar FIFO
                if (autorizacionModificar.peticionTipo === "Petición 1. Autorizar no aplicar FIFO") {
                    datosReciba.autPNoFIFO1 = resolucion;
                    datosReciba.autPPNoFIFOComentTIOA1 = motivosR;

                }
                setMensajeAlert("Revisando datos5");
                //Si se trata de Petición 2. Autorizar no aplicar FIFO
                if (autorizacionModificar.peticionTipo === "Petición 2. Autorizar no aplicar FIFO") {
                    datosReciba.autPNoFIFO2 = resolucion;
                    datosReciba.autPPNoFIFOComentTIOA2 = motivosR;
                }
                setMensajeAlert("Revisando datos6");
                //Plan de producción
                if (autorizacionModificar.peticionTipo === "Petición 2. Autorizar no aplicar FIFO" ||
                    autorizacionModificar.peticionTipo === "Petición 1. Autorizar no aplicar FIFO") {

                    //Se obtienen los datos de las resoluciones correspondientes a la solicitud de plan de producción
                    const ppResolucion1 = datosReciba.autPNoFIFO1 ? datosReciba.autPNoFIFO1 : "";
                    const ppResolucion2 = datosReciba.autPNoFIFO2 ? datosReciba.autPNoFIFO2 : "";
                    const ppResolucionM1 = datosReciba.autPPNoFIFOComentTIOA1 ? datosReciba.autPPNoFIFOComentTIOA1 : "";
                    const ppResolucionM2 = datosReciba.autPPNoFIFOComentTIOA2 ? datosReciba.autPPNoFIFOComentTIOA2 : "";

                    if (ppResolucion1 && ppResolucion2) {
                        datosReciba.autNoFIFO = ppResolucion1 === ppResolucion2 ? ppResolucion1 : "Rechazada";
                        datosReciba.autPNoFIFOComentTIOA = "Motivos 1: " + ppResolucionM1 + " Motivos 2: " + ppResolucionM2;
                    }

                }
                setMensajeAlert("Revisando datos7");
                //Si se trata de Autorizar no aplicar FIFO. Planeación.
                if (autorizacionModificar.peticionTipo === "Autorizar no aplicar FIFO") {
                    datosReciba.autNoFIFO = resolucion;
                    datosReciba.autPNoFIFOComentTIOA = motivosR;
                }

                //Si se trata de Autorizar Omitir registro de Carga
                if (autorizacionModificar.peticionTipo === "Omitir registro de Carga") {
                    datosReciba.omitirCarga = resolucion;
                    datosReciba.omitirCargaComent = (datosReciba.omitirCargaComent ? datosReciba.omitirCargaComent + ", " : "") + resolucion + "-" + motivosR;
                }

                //Si se trata de Autorizar Omitir registro de Pintado.
                if (autorizacionModificar.peticionTipo === "Omitir registro de Pintado") {
                    datosReciba.omitirPintado = resolucion;
                    datosReciba.omitirPintadoComent = (datosReciba.omitirPintadoComent ? datosReciba.omitirPintadoComent + ", " : "") + resolucion + "-" + motivosR;
                }

                //Si se trata de Autorizar Omitir registro de Pintado.
                if (autorizacionModificar.peticionTipo === "Omitir registro de Inspección final") {
                    datosReciba.omitirIFinal = resolucion;
                    datosReciba.omitirIFinalComent = (datosReciba.omitirIFinalComent ? datosReciba.omitirIFinalComent + ", " : "") + resolucion + "-" + motivosR;
                }
                setMensajeAlert("Revisando datos8");
                datosReciba.Reg_Mod_Usuario = userName;
                setMensajeAlert("Problemas al actualizar los datos de reciba");
                let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: datosReciba } });
                const recibaU = upRecibaS.data.updateRecibaSeriales;
                setMensajeAlert("Revisando datos9");

                //Se actualizan los datos en recibaSerialesMP
                const recibaSerialMPID = datosReciba.recibaSerialMPID;
                if (datosReciba.recibaSerialMPID) {
                    delete datosReciba.recibaSerialMPID;
                    setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(datosReciba));
                    await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...datosReciba, id: recibaSerialMPID, rsUpdatedAt: recibaU.updatedAt } }, });
                }

                //Se actualizan los datos de la autorización en la tabla de Autorizaciones
                var datosAutorizacion = solicitudFromAPI[0];
                delete datosAutorizacion.createdAt;
                delete datosAutorizacion.updatedAt;
                delete datosAutorizacion.__typename;
                datosAutorizacion.resolucion = resolucion;
                datosAutorizacion.resolucionUsuario = nombreCompletoUsuario;
                datosAutorizacion.resolucionComentarios = motivosR;
                datosAutorizacion.resolucionFecha = Moment(new Date()).format("YYYY-MM-DD");
                datosAutorizacion.resolucionHora = Moment(new Date()).format("HH:mm");
                datosAutorizacion.Reg_Mod_Usuario = userName;
                setMensajeAlert("Problemas al actualizar la solicitud " + JSON.stringify(datosAutorizacion));//+ JSON.stringify(datosAutorizacion)
                await API.graphql({ query: updateAutorizaciones, variables: { input: datosAutorizacion } });

                window.scrollTo(0, 0);
                setMensajeAlert("Operación exitosa: se requiere llamar por teléfono a " + datosAutorizacion.peticionUsuario + " e informarle de la resolución de la solicitud en cuestión");
                setColor("primary");
                setAVisible(true);
                setCargando(false);
                setMotivosR("");
                setResolucion("");
                fetchAutorizaciones();

            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se actualizarán los datos de almacén, " +
                    "una vez que se actualicen los datos, se requiere volver a intentarlo.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchAutorizaciones();
            }

        } catch (e) {

            //setMensajeAlert(JSON.stringify(e));
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            window.scrollTo(0, 0);
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }

    };
    //Evento que revisa el cambio en tipo de búsqueda
    function onSearchBy(e) {
        setAVisible(false);
        setCargando(false);
        setSearchBy(e.target.value);
        if (search)
            busqueda(autorizacionesSinFIltro, e.target.value, search, resolucionAutorizacion, currentPage);
    }
    //Evento que revisa el cambio en el filtro por estado del cliente
    function onEstadoResolucion(e) {
        setAVisible(false);
        setCargando(false);
        setResolucionAutorizacion(e.target.value);
        busqueda(autorizacionesSinFIltro, searchBy, search, e.target.value, currentPage);
    }
    //Evento que revisa el cambio en la búsqueda
    function onSearch(e) {
        setAVisible(false);
        setCargando(false);
        busqueda(autorizacionesSinFIltro, searchBy, search, resolucionAutorizacion, currentPage);
    }
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busqueda(autorizacionesSinFIltro, searchBy, e.target.value, resolucionAutorizacion, currentPage);
    };
    return (
        <>
            {pAutorizaciones === true && (
                <>
                    <div className="conteiner2">
                        <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                            {mensajeAlert}
                        </Alert>
                        {cargando === true && (
                            <Row>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            </Row>
                        )}
                        <Fragment>
                            <div>

                                <Row>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-left margintop20px">
                                        <Label><h5>Busqueda por: </h5></Label>
                                        <select className="ml-2" onChange={onSearchBy}>
                                            <option value="cliente" selected={searchBy === "cliente" ? true : false}>Cliente</option>
                                            <option value="número de parte" selected={searchBy === "número de parte" ? true : false}>Número de parte</option>
                                            <option value="serial" selected={searchBy === "serial" ? true : false}>Serial</option>
                                            <option value="serialBTI" selected={searchBy === "serialBTI" ? true : false}>SerialBTI</option>
                                            <option value="tipo de petición" selected={searchBy === "tipo de petición" ? true : false}>Tipo de petición</option>
                                            <option value="módulo" selected={searchBy === "módulo" ? true : false}>Módulo</option>
                                            <option value="motivos" selected={searchBy === "motivos" ? true : false}>Motivos</option>
                                            <option value="fecha" selected={searchBy === "fecha" ? true : false}>Fecha</option>
                                        </select>
                                        <select className="resolucionPeticion ml-2" onChange={onEstadoResolucion}>
                                            <option value="todos" selected={resolucionAutorizacion === "todos" ? true : false}>Todas las resoluciones</option>
                                            <option value="Aceptada" style={{ color: "blue" }} selected={resolucionAutorizacion === "Aceptada" ? true : false}>Aceptadas</option>
                                            <option value="Rechazada" style={{ color: "red" }} selected={resolucionAutorizacion === "Rechazada" ? true : false}>Rechazadas</option>
                                            <option value="" selected={resolucionAutorizacion === "" ? true : false}>Sin resolución</option>
                                        </select>
                                        <Input
                                            type={searchBy !== "fecha" ? "text" : "date"}
                                            placeholder={"Búsqueda por " + searchBy}
                                            onChange={searchBy !== "fecha" ? (e) => setSearch(e.target.value) : onSearchFecha}
                                            onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                                            value={search}
                                        />
                                    </div>
                                </Row>
                                <div >
                                    <Row>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  " >
                                            <button className="cbutton btn-dark floatright   marginrightmobil3p " title="Recargar página" onClick={() => { fetchAutorizaciones(); }}><IoIcons.IoMdRefresh /> Recargar </button>
                                        </div>
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                            <Table className=" mb-2 scroll " >
                                                <Thead class="thead-secondary">
                                                    <Tr>
                                                        <Th>#</Th>
                                                        <Th className="minwidth150px">Cliente</Th>
                                                        <Th className="minwidth150px">Número de parte</Th>
                                                        <Th className="minwidth150px">Descripción</Th>
                                                        <Th className="minwidth60px">Serial</Th>
                                                        <Th className="minwidth100px">SerialBTI</Th>
                                                        <Th className="minwidth100px">Tipo de petición</Th>
                                                        <Th className="minwidth100px">Módulo</Th>
                                                        <Th className="minwidth100px">Motivos de petición</Th>
                                                        <Th className="minwidth100px">Fecha y hora de petición</Th>
                                                        <Th className="minwidth60px">Acciones</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {autorizaciones.map((autorizacion, i) => (
                                                        <Tr className={autorizacion.resolucion === "Aceptada" ? "table-info" : autorizacion.resolucion === "Rechazada" ? "table-danger" : (i % 2) !== 0 ? "table-active" : ""} >
                                                            <Td>{i + 1}</Td>
                                                            <Td>{autorizacion.cliente}</Td>
                                                            <Td>{autorizacion.numerodeParte}</Td>
                                                            <Td >{autorizacion.descripcion}</Td>
                                                            <Td className={autorizacion.descripcion ? "" : "margintopmobil20px"}>{autorizacion.serial}</Td>
                                                            <Td >{autorizacion.serialRecibaBTI}</Td>
                                                            <Td >{autorizacion.peticionTipo}</Td>
                                                            <Td >{autorizacion.peticionModulo}</Td>
                                                            <Td >{autorizacion.peticionMotivos}</Td>
                                                            <Td >{autorizacion.peticionFecha + " " + autorizacion.peticionHora}</Td>
                                                            <Td >
                                                                <button className="cbutton btn-primary  mb-2" title="Resolución" onClick={() => { clicAutorizar(autorizacion); }}><IoIcons.IoMdCheckboxOutline /> </button>
                                                                {/*<button className="cbutton btn-info " title="Detalles" onClick={() => { fetchAutorizaciones(); }}><IoIcons.IoIosListBox /> </button>*/}
                                                            </Td>
                                                        </Tr>

                                                    ))}
                                                </Tbody>
                                            </Table>
                                        </div>
                                    </Row>
                                </div>
                                {totalRecords > 0 && (
                                    <>
                                        <div className="mt-3 mb-3">
                                            Página {currentPage}, mostrando del {(recordPerPage * currentPage - recordPerPage) + 1}  al {totalRecords < recordPerPage * currentPage ? totalRecords : recordPerPage * currentPage} de {totalRecords} registros
                                        </div>
                                        <Row>
                                            <div className="col-lg-12 col-md-12 col-sm-12  " >
                                                <div className="floatcenter">
                                                    <Pagination
                                                        itemClass="page-item" // add it for bootstrap 4
                                                        linkClass="page-link" // add it for bootstrap 4                                    
                                                        activePage={currentPage}
                                                        itemsCountPerPage={recordPerPage}
                                                        totalItemsCount={totalRecords}
                                                        pageRangeDisplayed={pageRange}
                                                        onChange={handlePageChange}
                                                    />
                                                </div>
                                            </div>
                                        </Row>
                                    </>
                                )}

                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pProduccionSinFiltro)}</div>*/}
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(planeacionSinFiltro)}</div>*/}
                            </div>
                            <Modal isOpen={modal} toggle={toggle}>
                                <ModalHeader toggle={toggle}>Resolución de solicitudes </ModalHeader>
                                <ModalBody>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <Label>Solicitud*</Label>
                                        <select name="resolucion " className="custom-select" onChange={(e) => setResolucion(e.target.value)}>
                                            <option value="" selected={resolucion === "" ? true : false}>Elige una opción</option>
                                            <option value="Aceptada" selected={resolucion === "Aceptada" ? true : false}>Aceptada</option>
                                            <option value="Rechazada" selected={resolucion === "Rechazada" ? true : false}>Rechazada</option>
                                        </select>

                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px">
                                        <FormGroup>
                                            <Label className="floatleft ">Motivos*:</Label>
                                            <Input name="comentarios" maxLength={600} type="textarea" value={motivosR} rows="4" autoFocus onChange={(e) => setMotivosR(e.target.value)} />
                                        </FormGroup>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={resolucionSolicitud}>Aceptar</Button>{' '}
                                    <Button color="danger" onClick={toggle}>Salir</Button>
                                </ModalFooter>
                            </Modal>
                        </Fragment>
                    </div>
                </>
            )
            }
        </>
    )
};



export default Autorizaciones;
